import React from 'react';
import { Link } from 'react-router-dom';
import { media_url } from '../../hooks/useBlog';
import { FaClock, FaCalendar } from 'react-icons/fa';
import './NewsFeatured.scss';

const NewsFeatured = ({ posts }) => {
  if (!posts || posts.length === 0) return null;

  const mainPost = posts[0];
  const sidePosts = posts.slice(1, 4);

  return (
    <div className="news-featured-section">
      <div className="container-fluid">
        <div className="news-featured-grid">
          {/* Main Featured Post */}
          <Link 
            to={`/post/${mainPost.slug || mainPost.id}?id=${mainPost.id}`}
            className="news-featured-main"
          >
            <div 
              className="news-featured-image"
              style={{ backgroundImage: `url(${media_url(mainPost.image)})` }}
            >
              <div className="news-featured-overlay"></div>
              {mainPost.category && (
                <span className="news-category-badge">
                  {typeof mainPost.category === 'object' ? mainPost.category.name : mainPost.category}
                </span>
              )}
            </div>
            <div className="news-featured-content">
              <h2 className="news-featured-title">{mainPost.title}</h2>
              <p className="news-featured-excerpt">{mainPost.excerpt}</p>
              <div className="news-featured-meta">
                <span>
                  <FaCalendar /> {new Date(mainPost.created).toLocaleDateString('es-ES', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}
                </span>
                <span>
                  <FaClock /> 5 min lectura
                </span>
              </div>
            </div>
          </Link>

          {/* Side Featured Posts */}
          <div className="news-featured-side">
            {sidePosts.map((post, index) => (
              <Link 
                key={post.id}
                to={`/post/${post.slug || post.id}?id=${post.id}`}
                className="news-featured-item"
              >
                <div 
                  className="news-featured-item-image"
                  style={{ backgroundImage: `url(${media_url(post.image)})` }}
                >
                  {post.category && (
                    <span className="news-category-badge small">
                      {typeof post.category === 'object' ? post.category.name : post.category}
                    </span>
                  )}
                </div>
                <div className="news-featured-item-content">
                  <h3 className="news-featured-item-title">{post.title}</h3>
                  <p className="news-featured-item-excerpt">{post.excerpt}</p>
                  <div className="news-featured-item-meta">
                    <FaCalendar /> {new Date(post.created).toLocaleDateString('es-ES', {
                      day: 'numeric',
                      month: 'short'
                    })}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsFeatured;
